import snakeize from './snakeize';
class CustomFormData extends FormData {
    append(key, value) {
        super.append(snakeize(key), value);
    }
}
export default CustomFormData;
